var exports = {
  "pz": "sidebar__UTbGEu",
  "k2": "collapsedTreeToggle__GgU5t0",
  "Hc": "hiddenPane__fjKHfc",
  "R_": "heading__HIQ3k9",
};

module.exports = exports;
